import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * 모달을 document.body 로 보낸다.
 *
 * 왜 필요한가: 페이지 전환 애니메이션(.page-enter)이 transform 을 걸고 있고,
 * transform 이 걸린 요소는 자손의 position:fixed 기준(containing block)이 된다.
 * 그래서 모달을 페이지 안에 두면 목록을 스크롤한 만큼 오버레이가 밀려 올라가고
 * 높이도 화면 크기와 어긋난다. body 로 빼면 항상 뷰포트 기준이 된다.
 *
 * 열려 있는 동안 뒤 배경 스크롤도 막는다.
 */
export default function ModalPortal({ children }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, []);

  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
